/**
 * @generated SignedSource<<6b309734cf04b0cb666486c981e7f13a>>
 * @relayHash 47e8af21a1b55b6170b6b8c6d263a139
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 542e4a4137c33de1980ae75d67a35693680f429d9b801fe3e8d834f57d2dbab9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionAddApproverInput = {
  approverAccountId: string;
  versionId: string;
};
export type approverSelector_addApproverMutation$variables = {
  connections: ReadonlyArray<string>;
  input: JiraVersionAddApproverInput;
};
export type approverSelector_addApproverMutation$data = {
  readonly jira: {
    readonly addJiraVersionApprover: {
      readonly approverEdge: {
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"taskApprover_softwareReleasesApprovers_jiraVersionApprover">;
        } | null | undefined;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type approverSelector_addApproverMutation = {
  response: approverSelector_addApproverMutation$data;
  variables: approverSelector_addApproverMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "approverSelector_addApproverMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraVersionAddApproverPayload",
            "kind": "LinkedField",
            "name": "addJiraVersionApprover",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersionApproverEdge",
                "kind": "LinkedField",
                "name": "approverEdge",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraVersionApprover",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "taskApprover_softwareReleasesApprovers_jiraVersionApprover"
                      }
                    ]
                  }
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "approverSelector_addApproverMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraVersionAddApproverPayload",
            "kind": "LinkedField",
            "name": "addJiraVersionApprover",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersionApproverEdge",
                "kind": "LinkedField",
                "name": "approverEdge",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraVersionApprover",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "jobTitle"
                                  }
                                ]
                              }
                            ],
                            "type": "AtlassianAccountUser"
                          },
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "declineReason"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "handle": "prependEdge",
                "key": "",
                "kind": "LinkedHandle",
                "name": "approverEdge",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "542e4a4137c33de1980ae75d67a35693680f429d9b801fe3e8d834f57d2dbab9",
    "metadata": {},
    "name": "approverSelector_addApproverMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fbbec1648cd00fbc1991cee1a778d936";

export default node;
